import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.insetMedium};
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${tokens.spacing.insetMedium};
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.insetMedium};
`

export const WelcomeText = styled.strong`
  color: ${tokens.colors.dark6};
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.xlarge};
  text-align: center;
  margin: ${tokens.spacing.verticalXxlarge} 0;

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    display: none;
  }
`
